import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useContext, useMemo } from 'react';
const LoadingContext = createContext(undefined);
export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};
export const LoadingProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const contextValue = useMemo(() => ({ isLoading, setIsLoading }), [isLoading, setIsLoading]);
    return (_jsx(LoadingContext.Provider, { value: contextValue, children: children }));
};
